import { useEffect } from "preact/hooks";
import PublicHeader from "../components/PublicHeader.js";
import PublicFooter from "../components/PublicFooter.js";

export default function About() {
  useEffect(() => {
    document.title = "About — webhookstorage";

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      "About webhookstorage — the webhook buffer service for large payloads, built for automation platforms.",
    );

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://webhookstorage.com/about");

    window.scrollTo(0, 0);
  }, []);

  return (
    <div class="min-h-screen bg-white text-slate-900">
      <PublicHeader />
      <div class="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 class="mb-6 text-3xl font-bold tracking-tight">About webhookstorage</h1>

        <div class="space-y-6 text-base leading-relaxed text-slate-700">
          <p>
            webhookstorage is built and operated by{" "}
            <a
              href="https://sammons.io"
              class="text-teal-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sammons Software LLC
            </a>
            , a small software company out of O'Fallon, Missouri.
          </p>

          <p>
            The founder spent six years at Amazon building recognition, engagement, and
            authentication platforms at global scale — systems that handled hundreds of
            millions of requests and powered $75M+ in annual business impact. That
            experience shapes everything here: simple interfaces backed by battle-hardened
            infrastructure.
          </p>

          <p>
            webhookstorage exists because automation platforms like Zapier, Make, and n8n
            have payload size limits that silently break real workflows. If you've ever
            had a Shopify order webhook fail because the payload was too large, or
            watched a Make scenario choke on a 20 MB file — that's the problem we solve.
          </p>

          <p>
            We receive your webhooks (up to 250 MB), store them securely in S3, and
            forward a lightweight reference your automation can actually handle. Static
            IPs. Signed download links. Per-tenant isolation. No surprises.
          </p>

          <h2 class="pt-4 text-xl font-semibold text-slate-900">What we believe</h2>

          <ul class="ml-5 list-disc space-y-2">
            <li>
              <strong>Affordable services that scale simply.</strong> Pricing should be
              transparent and metered — you pay for what you use, and the free tier is
              free forever.
            </li>
            <li>
              <strong>Zero-config to first value.</strong> You should be able to test an
              endpoint in your browser before you write a single line of integration
              code.
            </li>
            <li>
              <strong>Build for anyone to use.</strong> Not just for companies with
              dedicated platform teams. If you're a solo operator stitching together
              Shopify, Zapier, and a spreadsheet — we built this for you.
            </li>
          </ul>

          <h2 class="pt-4 text-xl font-semibold text-slate-900">Get in touch</h2>

          <p>
            Questions, feedback, or partnership ideas:{" "}
            <a
              href="mailto:ben@sammons.io"
              class="text-teal-600 hover:underline"
            >
              ben@sammons.io
            </a>
          </p>
        </div>

      </div>
      <PublicFooter />
    </div>
  );
}
